import {format, parse} from 'date-fns';
import {ptBR} from 'date-fns/locale';

export function formatDateWithWeekday(date: string, dateFormat: string = 'P') {
	const dateObject = parse(date, dateFormat, 0, {locale: ptBR});

	const weekday = format(dateObject, 'EEEE', {
		locale: ptBR,
	});

	const day = format(dateObject, 'dd', {
		locale: ptBR,
	});

	const month = format(dateObject, 'MMMM', {
		locale: ptBR,
	});

	const monthNumber = format(dateObject, 'MM', {
		locale: ptBR,
	});

	const year = format(dateObject, 'yyyy', {
		locale: ptBR,
	});

	const formatted = format(dateObject, "EEEE, P 'às' HH:mm", {locale: ptBR});

	return {
		weekday,
		day,
		month,
		monthNumber,
		year,
		formatted,
	};
}
